import React from "react";

interface SupportArticleButtonProps {
  articleId: number
  label: string
}

const SupportArticleButton = ({ articleId, label }: SupportArticleButtonProps) => (
  <a
    className="button-support-article"
    onClick={(e) => {
      e.stopPropagation();
      window.OpenSupportSidebar(articleId);
    }}
  >
    <span className="subtitle-text-medium">{label}</span>
  </a>
);

export default SupportArticleButton;
